export interface IAppNotificationEvent {
    id: number;
    eventCode: string;
    eventName: string;
    notificationGroupAppsId: number;
    emailTemplateId?: string;
    smsTemplateId?: string;
    inAppTemplateId?: string;
    groupId?: number;
    /**
     * for ui rendering purposes
     */
    isOptedByUser?: boolean;
}

export class AppNotificationEvent implements IAppNotificationEvent {
    id: number;
    eventCode: string;
    eventName: string;
    notificationGroupAppsId: number;
    emailTemplateId?: string;
    smsTemplateId?: string;
    inAppTemplateId?: string;
    isOptedByUser?: boolean;
    groupId?: number;

    constructor(data: IAppNotificationEvent) {
        this.id = data.id;
        this.eventCode = data.eventCode;
        this.eventName = data.eventName;
        this.notificationGroupAppsId = data.notificationGroupAppsId;
        if (typeof data.emailTemplateId === 'string') { this.emailTemplateId = data.emailTemplateId; }
        if (typeof data.smsTemplateId === 'string') { this.smsTemplateId = data.smsTemplateId; }
        if (typeof data.inAppTemplateId === 'string') { this.inAppTemplateId = data.inAppTemplateId; }
        this.groupId = data.groupId;
        if (data.isOptedByUser) {
            this.isOptedByUser = data.isOptedByUser;
        }
    }
}

